import React, { useState } from 'react';
import ApartmentTenantService from '../../../services/ApartmentTenantService';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

function EditApartmentTenantComponent(props) {
    const [apartmentTenant, setApartmentTenant] = useState(props.apartmentTenant);

    const save = () => {
        if(apartmentTenant.id){
            ApartmentTenantService.updateApartmentTenant(apartmentTenant, props.apartment);
        }else {
            ApartmentTenantService.createApartmentTenant(apartmentTenant, props.apartment);
        }
    };

    return <div className={"row mb-2 " + props.warning}>
        <div className="col">
            <div className="row">
                <div className="col-md-3 panelRowPadding ">
                    <div>
                        <label>Fornavn</label>
                    </div>
                    <input className="form-control" name="type" value={apartmentTenant.tenant.firstname} onChange={(event) => setApartmentTenant({ ...apartmentTenant, tenant: {...apartmentTenant.tenant, firstname: event.target.value} })} type="text" />
                </div>
                <div className="col-md-3 panelRowPadding ">
                    <div>
                        <label>Efternavn</label>
                    </div>
                    <input className="form-control" name="type" value={apartmentTenant.tenant.lastname} onChange={(event) => setApartmentTenant({ ...apartmentTenant, tenant: {...apartmentTenant.tenant, lastname: event.target.value} })} type="text" />
                </div>
                <div className="col-md-3 panelRowPadding ">
                    <div>
                        <label>Telefon</label>
                    </div>
                    <input className="form-control" name="type" value={apartmentTenant.tenant.phone} onChange={(event) => setApartmentTenant({ ...apartmentTenant, tenant: {...apartmentTenant.tenant, phone: event.target.value} })} type="text" />
                </div>
                <div className="col-md-3 panelRowPadding ">
                    <div>
                        <label>Email</label>
                    </div>
                    <input className="form-control" name="type" value={apartmentTenant.tenant.email} onChange={(event) => setApartmentTenant({ ...apartmentTenant, tenant: {...apartmentTenant.tenant, email: event.target.value} })} type="text" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-3 panelRowPadding ">
                    <label>Indflytningdato</label>
                    <div className="form-control" style={{ border: 'none', padding: 0 }}>
                        <DatePicker 
                            format="dd/MM/yyyy" 
                            value={apartmentTenant.seniority_date ? new Date(apartmentTenant.seniority_date) : null} 
                            onChange={date => { 
                                setApartmentTenant({ 
                                    ...apartmentTenant, 
                                    seniority_date: date ? date.toISOString() : null 
                                })
                            }} 
                        />
                    </div>
                </div>
                <div className="col-md-3 panelRowPadding ">
                    <div>
                        <label>Seneste flytning</label><br />
                    </div>
                    <div className="form-control" style={{ border: 'none', padding: 0 }}>
                        <DatePicker 
                            format="dd/MM/yyyy" 
                            value={apartmentTenant.seniority_date2 ? new Date(apartmentTenant.seniority_date2) : null} 
                            onChange={date => { 
                                setApartmentTenant({ 
                                    ...apartmentTenant, 
                                    seniority_date2: date ? date.toISOString() : null 
                                })
                            }} 
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-2">
                    <button className="btn btn-primary" onClick={() => save()}>Gem ændringer</button>
                </div>
                <div className="col-2">
                    <button className="btn btn-primary" onClick={() => props.toggleEdit()}>Afbryd</button>
                </div>
            </div>
        </div>
    </div>;
}
export default EditApartmentTenantComponent;